// Curated multi-day "packs" — composed by the Xaluca concierge.
// Each pack stitches together stays, experiences and rituals across the south of Morocco.
// All copy is trilingual (en / fr / es) and rendered via the `pick(obj, lang)` helper.

export const PACKS = [
  {
    slug: "desert-soul-erg-chebbi",
    family: "desert",
    duration_days: 4,
    nights: 3,
    from_price_eur: 1950,
    image: "https://images.unsplash.com/photo-1542401886-65d6c61db217?auto=format&fit=crop&w=1800&q=80",
    accent: "#C16542",
    overline: {
      en: "Desert Pack · 04 nights",
      fr: "Pack désert · 04 nuits",
      es: "Pack desierto · 04 noches",
    },
    title: {
      en: "Desert Soul · Erg Chebbi",
      fr: "Âme du désert · Erg Chebbi",
      es: "Alma del desierto · Erg Chebbi",
    },
    tagline: {
      en: "Two nights inside a Sahrawi tent, one starlit dinner on the dune, and the Milky Way as a ceiling.",
      fr: "Deux nuits sous une tente sahraouie, un dîner étoilé sur la dune, et la Voie lactée comme toit.",
      es: "Dos noches en una tienda saharaui, una cena estrellada en la duna y la Vía Láctea como techo.",
    },
    includes: [
      { en: "1 night Kasbah Hotel Xaluca · Arfoud", fr: "1 nuit Kasbah Hotel Xaluca · Arfoud", es: "1 noche Kasbah Hotel Xaluca · Arfoud" },
      { en: "2 nights La Belle Étoile Luxury Camp", fr: "2 nuits La Belle Étoile Luxury Camp", es: "2 noches La Belle Étoile Luxury Camp" },
      { en: "Sunrise camel caravan · 90 min", fr: "Caravane de chameaux au lever du soleil · 90 min", es: "Caravana de camellos al amanecer · 90 min" },
      { en: "Berber tagine dinner under the stars", fr: "Dîner tagine berbère sous les étoiles", es: "Cena tajín bereber bajo las estrellas" },
    ],
    palette: { en: "Earth · copper · sand", fr: "Terre · cuivre · sable", es: "Tierra · cobre · arena" },
  },
  {
    slug: "atlas-refuge",
    family: "mountain",
    duration_days: 5,
    nights: 4,
    from_price_eur: 2250,
    image: "https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?auto=format&fit=crop&w=1800&q=80",
    accent: "#5A6B4F",
    overline: {
      en: "Mountain Pack · 05 nights",
      fr: "Pack montagne · 05 nuits",
      es: "Pack montaña · 05 noches",
    },
    title: {
      en: "Atlas Refuge",
      fr: "Refuge de l'Atlas",
      es: "Refugio del Atlas",
    },
    tagline: {
      en: "Four nights on mule trails and ridge lines — silence, snow on the highest passes, and Amazigh hospitality at the end of every day.",
      fr: "Quatre nuits sur sentiers à dos de mulet et lignes de crête — silence, neige sur les cols, et hospitalité amazighe en fin de journée.",
      es: "Cuatro noches por sendas y cordales — silencio, nieve en los puertos más altos y hospitalidad amazigh al cierre de cada jornada.",
    },
    includes: [
      { en: "4 nights Refuge Ifess Fess · M'Goun Massif", fr: "4 nuits Refuge Ifess Fess · Massif du M'Goun", es: "4 noches Refugio Ifess Fess · Macizo del M'Goun" },
      { en: "Mule-assisted trekking · Amazigh guide", fr: "Randonnée muletée · guide amazigh", es: "Senderismo con mula · guía amazigh" },
      { en: "Mountain cuisine · home produce", fr: "Cuisine de montagne · produits maison", es: "Cocina de montaña · productos de la casa" },
      { en: "Stargazing on the high plateau", fr: "Observation des étoiles sur le haut plateau", es: "Observación de estrellas en el altiplano" },
    ],
    palette: { en: "Cedar · slate · clay", fr: "Cèdre · ardoise · argile", es: "Cedro · pizarra · arcilla" },
  },
  {
    slug: "kasbah-heritage",
    family: "heritage",
    duration_days: 8,
    nights: 7,
    from_price_eur: 3400,
    image: "https://images.unsplash.com/photo-1539020140153-e479b8c22e70?auto=format&fit=crop&w=1800&q=80",
    accent: "#A07042",
    overline: {
      en: "Heritage Pack · 08 nights",
      fr: "Pack patrimoine · 08 nuits",
      es: "Pack patrimonio · 08 noches",
    },
    title: {
      en: "Kasbah Heritage Route",
      fr: "Route des Kasbahs",
      es: "Ruta de las Kasbahs",
    },
    tagline: {
      en: "From the palm groves of the Tafilalet to the ochre walls of a UNESCO ksar — a slow road through pisé, zellige and storied stone.",
      fr: "Des palmeraies du Tafilalet aux murs d'ocre d'un ksar UNESCO — une route lente à travers pisé, zellige et pierre habitée.",
      es: "De los palmerales del Tafilalet a los muros ocres de un ksar UNESCO — una ruta lenta entre pisé, zellige y piedra con historia.",
    },
    includes: [
      { en: "2 nights Kasbah Hotel Xaluca · Arfoud", fr: "2 nuits Kasbah Hotel Xaluca · Arfoud", es: "2 noches Kasbah Hotel Xaluca · Arfoud" },
      { en: "2 nights Hotel Xaluca Dades", fr: "2 nuits Hotel Xaluca Dades", es: "2 noches Hotel Xaluca Dades" },
      { en: "3 nights Xaluca Aït Ben Haddou Maison d'Hôte", fr: "3 nuits Xaluca Aït Ben Haddou Maison d'Hôte", es: "3 noches Xaluca Aït Ben Haddou Maison d'Hôte" },
      { en: "Private 4×4 with English / French driver", fr: "4×4 privé avec chauffeur français / anglais", es: "4×4 privado con chófer francés / inglés" },
    ],
    palette: { en: "Pisé · ochre · zellige", fr: "Pisé · ocre · zellige", es: "Pisé · ocre · zellige" },
  },
  {
    slug: "honeymoon-sahara",
    family: "romance",
    duration_days: 6,
    nights: 5,
    from_price_eur: 4200,
    image: "https://images.unsplash.com/photo-1570133435536-7ececf000ef6?crop=entropy&cs=srgb&fm=jpg&w=1800&q=80",
    accent: "#D4A373",
    overline: {
      en: "Romance Pack · 06 nights",
      fr: "Pack romance · 06 nuits",
      es: "Pack romance · 06 noches",
    },
    title: {
      en: "Honeymoon Sahara",
      fr: "Lune de miel saharienne",
      es: "Luna de miel sahariana",
    },
    tagline: {
      en: "A privatised six-tent camp, a sommelier-curated tasting, two rooftop dinners and a couples' hammam beneath the stars.",
      fr: "Un camp privatisé de six tentes, une dégustation conçue par un sommelier, deux dîners sur le toit et un hammam à deux sous les étoiles.",
      es: "Un campamento de seis tiendas privatizado, una cata diseñada por un sumiller, dos cenas en la azotea y un hammam para dos bajo las estrellas.",
    },
    includes: [
      { en: "2 nights Hotel Riad Xaluca · suite", fr: "2 nuits Hotel Riad Xaluca · suite", es: "2 noches Hotel Riad Xaluca · suite" },
      { en: "3 nights La Belle Étoile Luxury Camp Mini · privatised", fr: "3 nuits La Belle Étoile Luxury Camp Mini · privatisé", es: "3 noches La Belle Étoile Luxury Camp Mini · privatizado" },
      { en: "Couples' hammam · 90 min", fr: "Hammam à deux · 90 min", es: "Hammam para dos · 90 min" },
      { en: "Champagne sundown · dune crest", fr: "Coucher de soleil champagne · crête de dune", es: "Atardecer con champán · cresta de duna" },
    ],
    palette: { en: "Peach · gold · candlelight", fr: "Pêche · or · lueur de bougie", es: "Melocotón · oro · luz de vela" },
  },
  {
    slug: "family-adventure",
    family: "family",
    duration_days: 7,
    nights: 6,
    from_price_eur: 2800,
    image: "https://images.unsplash.com/photo-1547234935-80c7145ec969?auto=format&fit=crop&w=1800&q=80",
    accent: "#C16542",
    overline: {
      en: "Family Pack · 07 nights",
      fr: "Pack famille · 07 nuits",
      es: "Pack familia · 07 noches",
    },
    title: {
      en: "Family Adventure",
      fr: "Aventure en famille",
      es: "Aventura en familia",
    },
    tagline: {
      en: "Quad bikes for older kids, camel rides for the little ones, sandboarding for everyone, and a kasbah pool to land in every afternoon.",
      fr: "Quads pour les grands, dromadaires pour les petits, sandboard pour tous et une piscine de kasbah pour atterrir chaque après-midi.",
      es: "Quads para los mayores, dromedarios para los peques, sandboard para todos y una piscina de kasbah para aterrizar cada tarde.",
    },
    includes: [
      { en: "3 nights Kasbah Hotel Xaluca · family suite", fr: "3 nuits Kasbah Hotel Xaluca · suite familiale", es: "3 noches Kasbah Hotel Xaluca · suite familiar" },
      { en: "2 nights Bivouac La Belle Étoile · haima", fr: "2 nuits Bivouac La Belle Étoile · haïma", es: "2 noches Bivouac La Belle Étoile · jaima" },
      { en: "1 night Hotel Xaluca Dades", fr: "1 nuit Hotel Xaluca Dades", es: "1 noche Hotel Xaluca Dades" },
      { en: "Quad · camel · sandboarding · fossil hunt", fr: "Quad · dromadaire · sandboard · chasse aux fossiles", es: "Quad · camello · sandboard · busca de fósiles" },
    ],
    palette: { en: "Sand · sky · terracotta", fr: "Sable · ciel · terre cuite", es: "Arena · cielo · terracota" },
  },
  {
    slug: "photographers-journey",
    family: "creative",
    duration_days: 7,
    nights: 6,
    from_price_eur: 3100,
    image: "https://images.unsplash.com/photo-1547471080-7cc2caa01a7e?auto=format&fit=crop&w=1800&q=80",
    accent: "#1A1513",
    overline: {
      en: "Photographers' Pack · 07 nights",
      fr: "Pack photographes · 07 nuits",
      es: "Pack fotógrafos · 07 noches",
    },
    title: {
      en: "Photographer's Journey",
      fr: "Voyage du photographe",
      es: "Viaje del fotógrafo",
    },
    tagline: {
      en: "Six sunrises, six golden hours — composed routes through ksars, oases and dune crests, with a local guide who knows where the light falls.",
      fr: "Six levers de soleil, six heures dorées — itinéraires composés à travers ksars, oasis et crêtes de dune, avec un guide local qui sait où tombe la lumière.",
      es: "Seis amaneceres, seis horas doradas — itinerarios compuestos por ksars, oasis y crestas de duna, con un guía local que sabe dónde cae la luz.",
    },
    includes: [
      { en: "1 night Aït Ben Haddou · ksar interior", fr: "1 nuit Aït Ben Haddou · intérieur du ksar", es: "1 noche Aït Ben Haddou · interior del ksar" },
      { en: "2 nights Dades Valley · gorge views", fr: "2 nuits Vallée du Dadès · vues sur la gorge", es: "2 noches Valle del Dadès · vistas al cañón" },
      { en: "3 nights Erg Chebbi · sunrise dune", fr: "3 nuits Erg Chebbi · dune du levant", es: "3 noches Erg Chebbi · duna del amanecer" },
      { en: "Drone permits arranged · local fixer included", fr: "Permis drone obtenus · fixer local inclus", es: "Permisos de dron tramitados · fixer local incluido" },
    ],
    palette: { en: "Charcoal · ember · ivory", fr: "Anthracite · braise · ivoire", es: "Carbón · brasa · marfil" },
  },
  {
    slug: "stargazing-and-silence",
    family: "desert",
    duration_days: 4,
    nights: 3,
    from_price_eur: 1650,
    image: "https://images.unsplash.com/photo-1517825738774-7de9363ef735?auto=format&fit=crop&w=1800&q=80",
    accent: "#3A4A5F",
    overline: {
      en: "Astronomy Pack · 04 nights",
      fr: "Pack astronomie · 04 nuits",
      es: "Pack astronomía · 04 noches",
    },
    title: {
      en: "Stargazing & Silence",
      fr: "Étoiles & silence",
      es: "Estrellas y silencio",
    },
    tagline: {
      en: "Three nights at the edge of the dunes with a Bortle-2 sky — telescope sessions, Tuareg stories, and the kind of quiet that resets the nervous system.",
      fr: "Trois nuits à la lisière des dunes avec un ciel Bortle-2 — séances au télescope, contes touaregs, et un silence qui réinitialise tout.",
      es: "Tres noches al borde de las dunas con un cielo Bortle-2 — sesiones con telescopio, relatos tuareg y un silencio que lo reinicia todo.",
    },
    includes: [
      { en: "3 nights La Belle Étoile Luxury Camp", fr: "3 nuits La Belle Étoile Luxury Camp", es: "3 noches La Belle Étoile Luxury Camp" },
      { en: "Astronomer-guided sessions · telescope", fr: "Séances guidées par astronome · télescope", es: "Sesiones guiadas por astrónomo · telescopio" },
      { en: "Silent dune walks at first light", fr: "Marches silencieuses à l'aube sur les dunes", es: "Caminatas silenciosas al alba en las dunas" },
      { en: "Sound-bath under the open sky", fr: "Bain sonore à ciel ouvert", es: "Baño sonoro a cielo abierto" },
    ],
    palette: { en: "Ink · indigo · silver", fr: "Encre · indigo · argent", es: "Tinta · índigo · plata" },
  },
  {
    slug: "gastronomic-south",
    family: "table",
    duration_days: 6,
    nights: 5,
    from_price_eur: 2650,
    image: "https://images.unsplash.com/photo-1571902943202-507ec2618e8f?auto=format&fit=crop&w=1800&q=80",
    accent: "#B95F38",
    overline: {
      en: "Gastronomy Pack · 06 nights",
      fr: "Pack gastronomie · 06 nuits",
      es: "Pack gastronomía · 06 noches",
    },
    title: {
      en: "Gastronomic South",
      fr: "Le sud à table",
      es: "El sur a la mesa",
    },
    tagline: {
      en: "A twelve-hour mechoui, a Friday couscous around the family table, a souk-to-kitchen masterclass, and a fire-circle dinner under the dune.",
      fr: "Un méchoui de douze heures, le couscous du vendredi en famille, une masterclass du souk à la cuisine et un dîner en cercle de feu sous la dune.",
      es: "Un mechoui de doce horas, el cuscús del viernes en familia, una masterclass del zoco a la cocina y una cena en círculo de fuego bajo la duna.",
    },
    includes: [
      { en: "2 nights Kasbah Tombouctou · Merzouga", fr: "2 nuits Kasbah Tombouctou · Merzouga", es: "2 noches Kasbah Tombouctou · Merzouga" },
      { en: "1 night Bivouac · fire-circle dinner", fr: "1 nuit Bivouac · dîner cercle de feu", es: "1 noche Bivouac · cena en círculo de fuego" },
      { en: "2 nights Hotel Xaluca Spa Sidi Ali · lake trout", fr: "2 nuits Hotel Xaluca Spa Sidi Ali · truite du lac", es: "2 noches Hotel Xaluca Spa Sidi Ali · trucha del lago" },
      { en: "Souk masterclass + tagine workshop", fr: "Masterclass au souk + atelier tajine", es: "Masterclass en el zoco + taller de tajín" },
    ],
    palette: { en: "Saffron · pomegranate · clay", fr: "Safran · grenade · argile", es: "Azafrán · granada · arcilla" },
  },
];

// Available filter chips (label + matching `family` keys)
export const PACK_FAMILIES = [
  { id: "all", label: { en: "All packs", fr: "Tous les packs", es: "Todos los packs" } },
  { id: "desert", label: { en: "Desert & dunes", fr: "Désert & dunes", es: "Desierto y dunas" } },
  { id: "mountain", label: { en: "Mountain & atlas", fr: "Montagne & Atlas", es: "Montaña y Atlas" } },
  { id: "heritage", label: { en: "Heritage & ksars", fr: "Patrimoine & ksars", es: "Patrimonio y ksars" } },
  { id: "romance", label: { en: "Romance", fr: "Romance", es: "Romance" } },
  { id: "family", label: { en: "Family", fr: "Famille", es: "Familia" } },
  { id: "creative", label: { en: "Photography", fr: "Photographie", es: "Fotografía" } },
  { id: "table", label: { en: "Table & souk", fr: "Table & souk", es: "Mesa y zoco" } },
];
